import * as nodeURL from 'url';
import { FetchError } from './fetch-error';
import { MARQUEE_CSRF_COOKIE_NAME, MARQUEE_CSRF_HEADER_NAME } from './constants';
export var ContentTypes;
(function (ContentTypes) {
  ContentTypes["CSV"] = "application/vnd.ms-excel";
  ContentTypes["JSON"] = "application/json";
  ContentTypes["TEXT"] = "text/plain";
})(ContentTypes || (ContentTypes = {}));
export var HTTPMethod;
(function (HTTPMethod) {
  HTTPMethod["GET"] = "GET";
  HTTPMethod["POST"] = "POST";
  HTTPMethod["DELETE"] = "DELETE";
  HTTPMethod["PUT"] = "PUT";
})(HTTPMethod || (HTTPMethod = {}));
var jsonHeaders = {
  'Content-Type': ContentTypes.JSON,
  Accept: ContentTypes.JSON
};
var textHeaders = {
  'Content-Type': ContentTypes.JSON,
  Accept: ContentTypes.TEXT
};
var csvHeaders = {
  'Content-Type': ContentTypes.CSV,
  Accept: ContentTypes.CSV
};
var multiPartFormHeaders = {
  Accept: ContentTypes.JSON
};
var asJSON = function (response) {
  return response.json().then(function (body) {
    return {
      response: response,
      body: body
    };
  }, function () {
    return {
      response: response,
      body: null
    };
  });
};
var asTEXT = function (response) {
  return response.text().then(function (body) {
    return {
      response: response,
      body: body
    };
  }, function () {
    return {
      response: response,
      body: null
    };
  });
};
var checkStatus = function (parsedResponse) {
  if (parsedResponse.response.status >= 200 && parsedResponse.response.status < 400) {
    return parsedResponse.body;
  } else {
    var m = parsedResponse.response.statusText;
    throw new FetchError(m, m, parsedResponse.response.status, parsedResponse.body);
  }
};
var getRequestOptions = function (method, mimeheaders, opts, payload) {
  var csrfHeader = getCsrfHeader();
  var options = {
    headers: Object.assign({}, csrfHeader, mimeheaders, opts.headers),
    credentials: opts.credentials || 'same-origin',
    cache: opts.cache,
    mode: opts.mode,
    signal: opts.signal,
    method: method
  };
  if (payload instanceof FormData) {
    options.body = payload;
  } else if (method !== HTTPMethod.GET && typeof payload !== 'undefined') {
    // do *not* initialize the property to pass `hasOwnProperty` check
    options.body = JSON.stringify(payload);
  }
  return options;
};
var makeUpload = function (method, mimeheaders, parse) {
  return function (url, payload, opts) {
    if (payload instanceof FormData) {
      delete mimeheaders['Content-Type'];
    }
    return fetch(encodeURL(url), getRequestOptions(method, mimeheaders, opts || {}, payload)).then(parse).then(checkStatus);
  };
};
/** Does a POST to a JSON based REST endpoint. Returns a `Promise` with the parsed JSON body. Rejects the promise if responseCode is < 200 || >= 400 */
var post = makeUpload(HTTPMethod.POST, jsonHeaders, asJSON);
/** Does a POST to a text based REST endpoint. Returns a `Promise` with the parsed JSON body. Rejects the promise if responseCode is < 200 || >= 400 */
var postText = makeUpload(HTTPMethod.POST, textHeaders, asTEXT);
/** Does a POST to a multi-part form based REST endpoint. Returns a `Promise` with the parsed JSON body. Rejects the promise if responseCode is < 200 || >= 400 */
var postMultiPartForm = makeUpload(HTTPMethod.POST, multiPartFormHeaders, asJSON);
/** Does a PUT to a JSON based REST endpoint. Returns a `Promise` with the parsed JSON body. Rejects the promise if responseCode is < 200 || >= 400 */
var put = makeUpload(HTTPMethod.PUT, jsonHeaders, asJSON);
/** Does a PUT to a multi-part form based REST endpoint. Returns a `Promise` with the parsed JSON body. Rejects the promise if responseCode is < 200 || >= 400 */
var putMultiPartForm = makeUpload(HTTPMethod.PUT, multiPartFormHeaders, asJSON);
/** Does a DELETE to a JSON based REST endpoint. Returns a `Promise` with the parsed JSON body. Rejects the promise if responseCode is < 200 || >= 400. Method is named `dlete` because `delete` is a reserved word. */
var dlete = makeUpload(HTTPMethod.DELETE, jsonHeaders, asJSON);
/** Returns a `Promise` with the parsed JSON body. Rejects the promise if responseCode is < 200 || >= 400 */
var get = makeUpload(HTTPMethod.GET, jsonHeaders, asJSON);
var getCsv = makeUpload(HTTPMethod.GET, csvHeaders, asTEXT);
/** Returns a `Promise` with the text of body. Rejects the promise if responseCode is < 200 || >= 400 */
var getText = makeUpload(HTTPMethod.GET, textHeaders, asTEXT);
var encodeURL = function (url) {
  var urlObj = nodeURL.parse(url);
  var protocol = urlObj.protocol ? urlObj.protocol + "//" : '';
  var hostPort = urlObj.host || '';
  return protocol + hostPort + urlObj.pathname + (urlObj.search || '');
};
/**
 * See https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#Example_2_Get_a_sample_cookie_named_test2
 * for official cookie docs.
 */
var getCookie = function (name) {
  var regex = new RegExp('(?:(?:^|.*;\\s*)' + name + '\\s*\\=\\s*([^;]*).*$)|^.*$');
  return document.cookie.replace(regex, '$1');
};
var getCsrfHeader = function () {
  var _a;
  return _a = {}, _a[MARQUEE_CSRF_HEADER_NAME] = getCookie(MARQUEE_CSRF_COOKIE_NAME), _a;
};
/** wrapper around Fetch */
var request = {
  get: get,
  put: put,
  post: post,
  dlete: dlete,
  getText: getText,
  getCsv: getCsv,
  postText: postText,
  postMultiPartForm: postMultiPartForm,
  putMultiPartForm: putMultiPartForm,
  getRequestOptions: getRequestOptions,
  asTEXT: asTEXT,
  asJSON: asJSON,
  getCookie: getCookie,
  getCsrfHeader: getCsrfHeader
};
export { request };